import React, { useContext, useCallback } from 'react';
import { Route, Redirect } from 'react-router-dom';

import { LoggedUserContext } from 'contexts';

const PrivateRoute = ({ component: Component, redirect, ...rest }) => {
  const { loggedUser } = useContext(LoggedUserContext);

  const render = useCallback(
    props =>
      !!loggedUser ? (
        <Redirect
          to={{
            pathname: redirect,
            state: { from: props.location }
          }}
        />
      ) : (
        <Component {...props} />
      ),
    [loggedUser, redirect]
  );

  return <Route {...rest} render={render} />;
};

export default PrivateRoute;
